<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('pages.tableMaps')" class="text-left">
              <pos-map-list v-if="isTableMaps" :isTableMaps="isTableMaps"></pos-map-list>
            </v-tab>
            <v-tab :title="$t('pages.pos')" class="text-left">
              <pos-list v-if="isFirst" :isFirst="isFirst"></pos-list>
            </v-tab>
            <v-tab :title="$t('pages.posScreen')" class="text-left">
              <pos-screen v-if="isPosScreen"></pos-screen>
            </v-tab>
            <v-tab :title="$t('dispath.users')" class="text-left">
              <pos-settings-users v-if="isUser" :isUser="isUser"></pos-settings-users>
            </v-tab>
            <!-- <v-tab title="Reports" class="text-left">
              <pos-settings-reports v-if="isReport" :isReport="isReport"></pos-settings-reports>
            </v-tab>
            <v-tab title="Settings" class="text-left">
              <pos-settings-settings v-if="isSettings" :isSettings="isSettings"></pos-settings-settings>
            </v-tab> -->
            <v-tab title="Cantar" class="text-left">
              <cantar-list v-if="isCantar" :isCantar="isCantar"></cantar-list>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import PosList from './PosList.vue'
  import PosMapList from './PosMapList.vue'
  import PosSettingsUsers from './PosSettingsUsers.vue'
  // import PosSettingsSettings from './PosSettingsSettings.vue'
  // import PosSettingsReports from './PosSettingsReports.vue'
  import CantarList from './CantarList.vue'
  import PosScreen from '../Screens/OrderScreen/PosScreen.vue'

  export default {
    components: {
      PosList,
      PosMapList,
      PosSettingsUsers,
      CantarList,
      PosScreen
      // PosSettingsSettings,
      // PosSettingsReports
    },
    data () {
      return {
        isTableMaps: false,
        isFirst: false,
        isUser: false,
        isCantar: false,
        isReport: false,
        isSettings: false,
        isPosScreen: false
        // isReport: false,
        // isSettings: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isTableMaps = false
        this.isFirst = false
        this.isUser = false
        this.isCantar = false
        this.isReport = false
        this.isSettings = false
        this.isPosScreen = false
        // this.isReport = false
        // this.isSettings = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('pages.tableMaps'):
            this.isTableMaps = true
            break
          case this.$t('dispath.users'):
            this.isUser = true
            break
          // case 'Reports':
          //   this.isReport = true
          //   break
          case 'Cantar':
            this.isCantar = true
            break
          // case 'Settings':
          //   this.isSettings = true
          //   break
          case this.$t('pages.posScreen'):
            this.isPosScreen = true
            break
          default:
            this.isFirst = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/PosTabs.vue